import Vue from "vue";
import {
  ObjectEx
} from "vue-objectex";

export class QuestionnaireQuestionEx extends ObjectEx {
  constructor(data = null, funcExtensions = null, defineProps = null) {
    let options = [{
      key: "data",
      value: data
    }];

    if (!!data) {
      if (!Object.keys(data).contains("_value")) {
        Vue.defineField(data, "_value", null);
      }

      if (!Object.keys(data).contains("_errorMessage")) {
        Vue.defineField(data, "_errorMessage", null);
      }
    }

    let innerFuncExtensions = {
      validate() {
        if (this.data.IsRequired) {
          if (this.Value === null) {
            this.ErrorMessage = "该题为必填。";
            return false;
          }

          if (this.data.IsMultiple && this.Value.length === 0) {
            this.ErrorMessage = "该题为必填。";
            return false;
          }
        }

        this.ErrorMessage = null;
        return true;
      }
    };
    if (Object.typeOf(funcExtensions) === "object") {
      Object.copy(innerFuncExtensions, funcExtensions);
    }

    let innerDefineProps = {
      Value: {
        get() {
          return this.data._value;
        },
        set(value) {
          this.data._value = value;
          this.validate();
        }
      },
      ErrorMessage: {
        get() {
          return this.data._errorMessage;
        },
        set(value) {
          this.data._errorMessage = value;
        }
      },
      AnswerOptionsEx: {
        get() {
          if (!this.data) return [];

          let answerOptions = this.data.AnswerOptions.filter(item => item.Enable).sortObject("Index");
          return answerOptions.map(item => ({
            label: item.Label,
            value: item.Value
          }));
        }
      }
    };
    if (Object.typeOf(defineProps) === "object") {
      Object.copy(innerDefineProps, defineProps);
    }

    super(options, innerFuncExtensions, innerDefineProps);
  }
}

export class QuestionnaireEx extends ObjectEx {
  constructor(data = null, funcExtensions = null, defineProps = null) {
    let options = [{
      key: "data",
      value: data
    }];

    let questionsEx = data.Questions.map(item => {
      if (item.constructor.name === "_ObjectEx")
        return item;

      return new QuestionnaireQuestionEx(item)
    });
    data.Questions = questionsEx;

    let innerFuncExtensions = {
      validate() {
        let isValid = true;

        for (let i = 0; i < this.data.Questions.length; i++) {
          let question = this.data.Questions[i];
          // if (!question.validate()) {
          //   isValid = false;
          //   break;
          // }
          isValid &= question.validate();
        }

        return !!isValid;
      },
      createStudentQuestionnaireRecord(studentId, courseId, termId = null) {
        let data = {
          StudentId: studentId,
          CourseId: courseId,
          TermId: termId,
          QuestionnaireId: this.data.Id,
          StudentAnswers: this.data.Questions.map(item => ({
            QuestionnaireQuestionId: item.data.Id,
            Value: item.Value
          }))
        };

        return data;
      }
    };
    if (Object.typeOf(funcExtensions) === "object") {
      Object.copy(innerFuncExtensions, funcExtensions);
    }

    let innerDefineProps = {};
    if (Object.typeOf(defineProps) === "object") {
      Object.copy(innerDefineProps, defineProps);
    }

    super(options, innerFuncExtensions, innerDefineProps);
  }
}



// WEBPACK FOOTER //
// ./src/model/questionnaireEx.js